export default () => {
  const select = document.querySelector('select.c-blog-hub__filters-mobile');
  select?.addEventListener('change', () => {
    window.location.href = select.value;
  });
};
